import BoardTabsComponent from "./board-tabs-component";
import BoardTabsConfig from "./board-tabs-config";
import BoardTabsAdvancedConfig from "./board-tabs-advanced-config";

export default {
  BoardTabsComponent,
  BoardTabsConfig,
  BoardTabsAdvancedConfig
};
